import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const HoteDetailMobileSkeleton = () => {
  return (
    <div className="hotel-DetailMobile">
      <div className="hotel-DetailMobile-header">
        <div className="hotel-DetailMobile-hotelName">
          <div className="hotelListingstyling-name">
            <div className="hotel-name-star-container">
              <div className="hotel-name-text">
                {" "}
                <Skeleton width={150} />
              </div>
            </div>

            <div className="hotel-Address hotel-AddressMobile">
              <span>
                <Skeleton width={600} />
              </span>
            </div>
          </div>
        </div>

        <div className="hotel-ColbigSilder">
          <div className="hotel-bigSilder">
            <Skeleton width={390} height={260}/>
          </div>
        </div>
        <div className="hotel-DetailMobile-roomsTabMain">
          <div className="hotel-DetailMobile-roomsTab">
          <Skeleton width={365}/>
            {/* <div className="hotel-tab hotel-tab-active"></div>
            <div className="hotel-tab hotel-tab-active">Overview</div>
            <div className="hotel-tab hotel-tab-active">Details</div> */}
          </div>

          <div className="room-card">
            <div className="room-card-top">
             <Skeleton width={100} height={100}/>
              <div className="room-info">
                <h4 className="room-title"><Skeleton width={100}/></h4>
                <div className="room-bed">
                 
                  <Skeleton width={150}/>
                </div>
                
              </div>
            </div>

            <div className="room-card-bottom">
              <div className="room-details">
                <h5 className="room-selection">
                  {/* <label className="hotel-radio-label">
            <input
              type="radio"
              name="roomSelection"
              className="custom-radio"
              checked={selectedRoomIndex === index}
              onChange={() => setSelectedRoomIndex(index)}
            />
            <span className="custom-radio-mark"></span>
            {room.Name[0]}
          </label> */}
                </h5>

                <ul className="room-details-list">
                  <li>
                   <Skeleton width={150}/>
                  </li>
                  <li><Skeleton width={150}/></li>
                  <li><Skeleton width={150}/></li>
                </ul>
              </div>
              <div className="room-price">
                <div className="strike-price"><Skeleton width={100}/></div>
                <div className="final-price"><Skeleton width={120}/></div>
                <div className="tax-info">
                <Skeleton width={150}/>
                
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HoteDetailMobileSkeleton;
